import { render, staticRenderFns } from "./nwp.vue?vue&type=template&id=51598fd6&"
import script from "./nwp.js?vue&type=script&lang=js&"
export * from "./nwp.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports